import type { CobrandingTokens } from '../../../theming/types'
import type { ButtonProps } from '..'

type Kind = 'main' | 'primary'

type KindStyles = {
  [key in Kind]: {
    color?: {
      backgroundColor?: string
      color?: string
    }
    hover?: {
      backgroundColor?: string
      color?: string
    }
    active?: {
      backgroundColor?: string
    }
    disabled?: {
      backgroundColor?: string
      color?: string
    }
    icon?: {
      [key: string]: string
    }
    border?: {
      borderInlineStartColor?: string
    }
  }
}

export default (config: {
  tokens: CobrandingTokens
  props: Pick<ButtonProps, 'kind'>
}) => {
  const { tokens, props } = config
  const kind = props.kind === 'brand' ? 'main' : (props.kind as Kind)

  // short circuit if no main or primary tokens
  if (
    !tokens.buttonMainBackgroundColor &&
    !tokens.buttonPrimaryBackgroundColor
  ) {
    return {}
  }

  const kindStyles: KindStyles = {
    main: {
      color: {
        backgroundColor: tokens.buttonMainBackgroundColor,
        color: tokens.buttonMainTextColor,
      },
      hover: {
        backgroundColor: tokens.buttonMainBackgroundHoverColor,
        color: tokens.buttonMainTextColor,
      },
      active: {
        backgroundColor: tokens.buttonMainBackgroundActiveColor,
      },
      disabled: {
        color: tokens.buttonMainTextColor,
        backgroundColor: tokens.buttonMainBackgroundColor,
      },
      border: {
        borderInlineStartColor: tokens.buttonMainTextColor,
      },
    },
    primary: {
      color: {
        backgroundColor: tokens.buttonPrimaryBackgroundColor,
        color: tokens.buttonPrimaryTextColor,
      },
      hover: {
        backgroundColor: tokens.buttonPrimaryBackgroundHoverColor,
        color: tokens.buttonPrimaryTextColor,
      },
      active: {
        backgroundColor: tokens.buttonPrimaryBackgroundActiveColor,
      },
      disabled: {
        color: tokens.buttonPrimaryTextColor,
        backgroundColor: tokens.buttonPrimaryBackgroundColor,
      },
      border: {
        borderInlineStartColor: tokens.buttonPrimaryTextColor,
      },
    },
  }

  return {
    button: {
      default: {
        ...kindStyles[kind]?.color,

        '&:hover': { ...kindStyles[kind]?.hover },
        '&:active, &[aria-expanded="true"]': { ...kindStyles[kind]?.active },
        '&:disabled': { ...kindStyles[kind]?.disabled },
      },

      active: {
        ...kindStyles[kind]?.active,
      },

      // These styles are only used in FileInput Component
      disabled: {
        '&:hover': {
          ...kindStyles[kind]?.disabled,
        },
      },

      // These styles are only used in ButtonGroup and the ComboButton components
      buttonSeparatorColor: {
        ...kindStyles[kind]?.border,
      },
    },
  } as const
}
